import { createTheme } from '@mui/material/styles';

// 浅色主题
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1B365D', // 深海蓝
    },
    secondary: {
      main: '#FF6B35', // 温暖橙
    },
    background: {
      default: '#F8F9FA',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Source Han Sans", "Microsoft YaHei", sans-serif',
    h3: {
      fontWeight: 600,
      color: '#1B365D',
    },
    h5: {
      fontWeight: 500,
      color: '#666666',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          transition: 'all 0.3s ease',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          transition: 'all 0.3s ease',
        },
      },
    },
  },
});

// 深色主题
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#4A90E2', // 较亮的蓝色
    },
    secondary: {
      main: '#FF8C42', // 较亮的橙色
    },
    background: {
      default: '#0f0f0f',
      paper: '#1a1a1a',
    },
    text: {
      primary: '#ffffff',
      secondary: '#cccccc',
    },
    divider: '#333333',
  },
  typography: {
    fontFamily: '"Source Han Sans", "Microsoft YaHei", sans-serif',
    h3: {
      fontWeight: 600,
      color: '#4A90E2',
    },
    h5: {
      fontWeight: 500,
      color: '#cccccc',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          transition: 'all 0.3s ease',
          backgroundColor: '#1a1a1a',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          transition: 'all 0.3s ease',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#2a2a2a',
            '& fieldset': {
              borderColor: '#444444',
            },
            '&:hover fieldset': {
              borderColor: '#666666',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#4A90E2',
            },
            '& input': {
              color: '#ffffff',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#cccccc',
          },
        },
      },
    },
  },
});